// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBar_header__F1kNi {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  /* frosted glass: content blurs through, a hairline highlight marks the edge */
  background: rgba(10, 12, 15, 0.82);
  backdrop-filter: blur(16px) saturate(150%);
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.07), 0 10px 30px -18px rgba(0, 0, 0, 0.7);
  font-family: var(--font-sans);
  transition: background-color 0.45s var(--ease-out), box-shadow 0.45s var(--ease-out),
    backdrop-filter 0.45s var(--ease-out);
}
.NavBar_transparent__NX3xP {
  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
}
/* backdrop-filter would make the full-screen mobile menu position against the
   80px header instead of the viewport */
.NavBar_menuOpen__fhrlm {
  backdrop-filter: none;
}
.NavBar_transparent__NX3xP::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.35) 55%, rgba(0, 0, 0, 0) 100%);
  z-index: -1;
  pointer-events: none;
}

.NavBar_bar__SkUDX {
  max-width: calc(var(--container) + var(--gutter) * 2);
  margin: 0 auto;
  box-sizing: border-box;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 0 var(--gutter);
}

/* Brand */
.NavBar_brand__0Bu5q {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem 0.5rem 0;
  text-decoration: none;
  flex: none;
}
.NavBar_logo__5sxlx {
  height: 70px;
  object-fit: contain;
  z-index: 2;
}
.NavBar_logoLarge__gAH8q {
  height: 250%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.NavBar_tagline__p0xZq {
  margin-left: 1em;
  font-size: 0.5rem;
  line-height: 1.2;
  font-weight: 700;
  color: var(--kur-yellow-soft);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.NavBar_taglineVisible__EA3j8 {
  opacity: 1;
}

/* Desktop nav */
.NavBar_desktopNav__0pUHe {
  display: none;
}
.NavBar_list__VY7QQ {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 1.6vw, 1.75rem);
}
.NavBar_link__zx-7z {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0;
  background: none;
  border: 0;
  font-family: var(--font-sans);
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.25s ease;
}
.NavBar_link__zx-7z::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--kur-amber);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.35s var(--ease-out);
}
.NavBar_link__zx-7z:hover,
.NavBar_link__zx-7z[aria-expanded="true"] {
  color: var(--kur-amber);
}
.NavBar_link__zx-7z:hover::after,
.NavBar_link__zx-7z[aria-expanded="true"]::after {
  transform: scaleX(1);
}
.NavBar_chevron__HAYwd {
  width: 0.45rem;
  height: 0.45rem;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg) translateY(-2px);
  transition: transform 0.25s var(--ease-out);
}
[aria-expanded="true"] > .NavBar_chevron__HAYwd {
  transform: rotate(225deg) translate(-1px, -1px);
}

/* Mega panel */
.NavBar_mega__w-3fs {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, #0e1014, #08090c);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 40px 60px -20px rgba(0, 0, 0, 0.6);
}
.NavBar_megaInner__3Ryim {
  max-width: calc(var(--container) + var(--gutter) * 2);
  margin: 0 auto;
  padding: 2rem var(--gutter) 2.5rem;
  display: grid;
  grid-template-columns: 16rem minmax(0, 1fr) 17rem;
  gap: 2.5rem;
}
.NavBar_megaHeading__WHUdI {
  margin: 0 0 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
  color: #fff;
}
.NavBar_megaDesc__b37NR {
  margin: 0;
  color: var(--color-text-muted-on-dark);
  line-height: 1.5;
  font-size: 0.95rem;
}
.NavBar_megaLinks__rBxGy {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.25rem 1.5rem;
  align-content: start;
}
.NavBar_megaLink__e0Cq3 {
  display: block;
  padding: 0.7rem 0;
  text-decoration: none;
  border-bottom: 1px solid var(--color-border-on-dark);
}
.NavBar_megaLinkLabel__xkvVq {
  display: block;
  font-weight: 700;
  color: #fff;
  transition: color 0.2s ease;
}
.NavBar_megaLinkText__gSetX {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.85rem;
  color: var(--color-text-muted-on-dark);
}
.NavBar_megaLink__e0Cq3:hover .NavBar_megaLinkLabel__xkvVq {
  color: var(--kur-amber);
}
.NavBar_featureWrap__Fr50f {
  display: flex;
}
.NavBar_feature__UBdjr {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem;
  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);
  background: var(--kur-gold);
  color: #111;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.25s var(--ease-out);
}
.NavBar_feature__UBdjr:hover {
  background: var(--kur-gold-hover);
  transform: translateY(-3px);
  color: #111;
}
.NavBar_featureLabel__Zt28B {
  font-size: 1.15rem;
  font-weight: 700;
}
.NavBar_featureText__ogOdT {
  font-size: 0.9rem;
}
.NavBar_featureArrow__ErSFg {
  margin-top: auto;
  font-size: 1.4rem;
}

/* Burger + mobile */
.NavBar_burger__qegqf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0.6rem;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 6px;
  cursor: pointer;
}
.NavBar_burger__qegqf span {
  display: block;
  height: 2px;
  background: #fff;
}
.NavBar_mobile__FBkWF {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: #000;
  padding: 5rem var(--gutter) 2rem;
  overflow-y: auto;
}
.NavBar_close__r3EXn {
  position: absolute;
  top: 1rem;
  right: var(--gutter);
  width: 2.75rem;
  height: 2.75rem;
  background: none;
  border: 0;
  color: #fff;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
}
.NavBar_mobileList__NI8pp,
.NavBar_mobileSub__uZvUG {
  margin: 0;
  padding: 0;
  list-style: none;
}
.NavBar_mobileTop__lop-c {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 0;
  background: none;
  border: 0;
  border-bottom: 1px solid var(--color-border-on-dark);
  font-family: var(--font-sans);
  font-size: 1.35rem;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.NavBar_mobileSub__uZvUG {
  padding: 0.5rem 0 1rem 1rem;
}
.NavBar_mobileSub__uZvUG a {
  display: block;
  padding: 0.6rem 0;
  color: var(--color-text-muted-on-dark);
  text-decoration: none;
  font-size: 1.05rem;
}
.NavBar_mobileSub__uZvUG a:hover {
  color: var(--kur-amber);
}
.NavBar_mobileFeature__b4YGY {
  color: var(--kur-gold) !important;
  font-weight: 700;
}

@media (min-width: 992px) {
  .NavBar_desktopNav__0pUHe {
    display: block;
  }
  .NavBar_burger__qegqf {
    display: none;
  }
}
@media (max-width: 991px) {
  .NavBar_megaInner__3Ryim {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/NAVBAR/NavBar.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8EAA8E;EAC9E,kCAAkC;EAElC,0CAA0C;EAC1C,0FAA0F;EAC1F,6BAA6B;EAC7B;yCACuC;AACzC;AACA;EACE,uBAAuB;EAEvB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;wCACwC;AACxC;EAEE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,0GAA0G;EAC1G,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,qCAAqC;EACrC,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,qDAAqD;EACrD,+CAA+C;EAC/C,yFAAyF;AAC3F;AACA;EACE,qDAAqD;EACrD,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,iDAAiD;EACjD,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oDAAoD;EACpD,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,iEAAiE;AACnE;AACA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oDAAoD;EACpD,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 9999;\n  /* frosted glass: content blurs through, a hairline highlight marks the edge */\n  background: rgba(10, 12, 15, 0.82);\n  -webkit-backdrop-filter: blur(16px) saturate(150%);\n  backdrop-filter: blur(16px) saturate(150%);\n  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.07), 0 10px 30px -18px rgba(0, 0, 0, 0.7);\n  font-family: var(--font-sans);\n  transition: background-color 0.45s var(--ease-out), box-shadow 0.45s var(--ease-out),\n    backdrop-filter 0.45s var(--ease-out);\n}\n.transparent {\n  background: transparent;\n  -webkit-backdrop-filter: none;\n  backdrop-filter: none;\n  box-shadow: none;\n}\n/* backdrop-filter would make the full-screen mobile menu position against the\n   80px header instead of the viewport */\n.menuOpen {\n  -webkit-backdrop-filter: none;\n  backdrop-filter: none;\n}\n.transparent::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 150px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.35) 55%, rgba(0, 0, 0, 0) 100%);\n  z-index: -1;\n  pointer-events: none;\n}\n\n.bar {\n  max-width: calc(var(--container) + var(--gutter) * 2);\n  margin: 0 auto;\n  box-sizing: border-box;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 0 var(--gutter);\n}\n\n/* Brand */\n.brand {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem 0.5rem 0;\n  text-decoration: none;\n  flex: none;\n}\n.logo {\n  height: 70px;\n  object-fit: contain;\n  z-index: 2;\n}\n.logoLarge {\n  height: 250%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n.tagline {\n  margin-left: 1em;\n  font-size: 0.5rem;\n  line-height: 1.2;\n  font-weight: 700;\n  color: var(--kur-yellow-soft);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n.taglineVisible {\n  opacity: 1;\n}\n\n/* Desktop nav */\n.desktopNav {\n  display: none;\n}\n.list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: clamp(0.75rem, 1.6vw, 1.75rem);\n}\n.link {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 0;\n  background: none;\n  border: 0;\n  font-family: var(--font-sans);\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.25s ease;\n}\n.link::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: var(--kur-amber);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.35s var(--ease-out);\n}\n.link:hover,\n.link[aria-expanded=\"true\"] {\n  color: var(--kur-amber);\n}\n.link:hover::after,\n.link[aria-expanded=\"true\"]::after {\n  transform: scaleX(1);\n}\n.chevron {\n  width: 0.45rem;\n  height: 0.45rem;\n  border-right: 2px solid currentColor;\n  border-bottom: 2px solid currentColor;\n  transform: rotate(45deg) translateY(-2px);\n  transition: transform 0.25s var(--ease-out);\n}\n[aria-expanded=\"true\"] > .chevron {\n  transform: rotate(225deg) translate(-1px, -1px);\n}\n\n/* Mega panel */\n.mega {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background: linear-gradient(180deg, #0e1014, #08090c);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 40px 60px -20px rgba(0, 0, 0, 0.6);\n}\n.megaInner {\n  max-width: calc(var(--container) + var(--gutter) * 2);\n  margin: 0 auto;\n  padding: 2rem var(--gutter) 2.5rem;\n  display: grid;\n  grid-template-columns: 16rem minmax(0, 1fr) 17rem;\n  gap: 2.5rem;\n}\n.megaHeading {\n  margin: 0 0 0.5rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n  color: #fff;\n}\n.megaDesc {\n  margin: 0;\n  color: var(--color-text-muted-on-dark);\n  line-height: 1.5;\n  font-size: 0.95rem;\n}\n.megaLinks {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.25rem 1.5rem;\n  align-content: start;\n}\n.megaLink {\n  display: block;\n  padding: 0.7rem 0;\n  text-decoration: none;\n  border-bottom: 1px solid var(--color-border-on-dark);\n}\n.megaLinkLabel {\n  display: block;\n  font-weight: 700;\n  color: #fff;\n  transition: color 0.2s ease;\n}\n.megaLinkText {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.85rem;\n  color: var(--color-text-muted-on-dark);\n}\n.megaLink:hover .megaLinkLabel {\n  color: var(--kur-amber);\n}\n.featureWrap {\n  display: flex;\n}\n.feature {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 1.5rem;\n  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);\n  background: var(--kur-gold);\n  color: #111;\n  text-decoration: none;\n  transition: background 0.2s ease, transform 0.25s var(--ease-out);\n}\n.feature:hover {\n  background: var(--kur-gold-hover);\n  transform: translateY(-3px);\n  color: #111;\n}\n.featureLabel {\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n.featureText {\n  font-size: 0.9rem;\n}\n.featureArrow {\n  margin-top: auto;\n  font-size: 1.4rem;\n}\n\n/* Burger + mobile */\n.burger {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  width: 2.75rem;\n  height: 2.75rem;\n  padding: 0.6rem;\n  background: none;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  border-radius: 6px;\n  cursor: pointer;\n}\n.burger span {\n  display: block;\n  height: 2px;\n  background: #fff;\n}\n.mobile {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  background: #000;\n  padding: 5rem var(--gutter) 2rem;\n  overflow-y: auto;\n}\n.close {\n  position: absolute;\n  top: 1rem;\n  right: var(--gutter);\n  width: 2.75rem;\n  height: 2.75rem;\n  background: none;\n  border: 0;\n  color: #fff;\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n}\n.mobileList,\n.mobileSub {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.mobileTop {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.1rem 0;\n  background: none;\n  border: 0;\n  border-bottom: 1px solid var(--color-border-on-dark);\n  font-family: var(--font-sans);\n  font-size: 1.35rem;\n  font-weight: 500;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.mobileSub {\n  padding: 0.5rem 0 1rem 1rem;\n}\n.mobileSub a {\n  display: block;\n  padding: 0.6rem 0;\n  color: var(--color-text-muted-on-dark);\n  text-decoration: none;\n  font-size: 1.05rem;\n}\n.mobileSub a:hover {\n  color: var(--kur-amber);\n}\n.mobileFeature {\n  color: var(--kur-gold) !important;\n  font-weight: 700;\n}\n\n@media (min-width: 992px) {\n  .desktopNav {\n    display: block;\n  }\n  .burger {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .megaInner {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `NavBar_header__F1kNi`,
	"transparent": `NavBar_transparent__NX3xP`,
	"menuOpen": `NavBar_menuOpen__fhrlm`,
	"bar": `NavBar_bar__SkUDX`,
	"brand": `NavBar_brand__0Bu5q`,
	"logo": `NavBar_logo__5sxlx`,
	"logoLarge": `NavBar_logoLarge__gAH8q`,
	"tagline": `NavBar_tagline__p0xZq`,
	"taglineVisible": `NavBar_taglineVisible__EA3j8`,
	"desktopNav": `NavBar_desktopNav__0pUHe`,
	"list": `NavBar_list__VY7QQ`,
	"link": `NavBar_link__zx-7z`,
	"chevron": `NavBar_chevron__HAYwd`,
	"mega": `NavBar_mega__w-3fs`,
	"megaInner": `NavBar_megaInner__3Ryim`,
	"megaHeading": `NavBar_megaHeading__WHUdI`,
	"megaDesc": `NavBar_megaDesc__b37NR`,
	"megaLinks": `NavBar_megaLinks__rBxGy`,
	"megaLink": `NavBar_megaLink__e0Cq3`,
	"megaLinkLabel": `NavBar_megaLinkLabel__xkvVq`,
	"megaLinkText": `NavBar_megaLinkText__gSetX`,
	"featureWrap": `NavBar_featureWrap__Fr50f`,
	"feature": `NavBar_feature__UBdjr`,
	"featureLabel": `NavBar_featureLabel__Zt28B`,
	"featureText": `NavBar_featureText__ogOdT`,
	"featureArrow": `NavBar_featureArrow__ErSFg`,
	"burger": `NavBar_burger__qegqf`,
	"mobile": `NavBar_mobile__FBkWF`,
	"close": `NavBar_close__r3EXn`,
	"mobileList": `NavBar_mobileList__NI8pp`,
	"mobileSub": `NavBar_mobileSub__uZvUG`,
	"mobileTop": `NavBar_mobileTop__lop-c`,
	"mobileFeature": `NavBar_mobileFeature__b4YGY`
};
export default ___CSS_LOADER_EXPORT___;
